import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { actionCreators } from 'dux/instances';
import ConnectTab from './ConnectTab';

const propTypes = {
  service: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  getInstanceCertificates: PropTypes.func.isRequired,
};

class ConnectTabContainer extends React.Component {
  componentDidMount() {
    const { service, id: instanceId, getInstanceCertificates } = this.props;
    if (
      service.toLowerCase() === 'cockroachdb' ||
      service.toLowerCase() === 'postgresql' ||
      service.toLowerCase() === 'timescaledb' ||
      service.toLowerCase() === 'mongodb'
    ) {
      getInstanceCertificates(service.toLowerCase(), instanceId);
    }
  }

  render() {
    return <ConnectTab {...this.props} />;
  }
}

const mapDispatchToProps = {
  getInstanceCertificates: actionCreators.getInstanceCertificates,
};

ConnectTabContainer.propTypes = propTypes;

export default connect(null, mapDispatchToProps)(ConnectTabContainer);
